export const FETCH_STOCK_ADJUSTMENT_REQUEST = "FETCH_STOCK_ADJUSTMENT_REQUEST";
export const FETCH_STOCK_ADJUSTMENT_SUCCESS = "FETCH_STOCK_ADJUSTMENT_SUCCESS";
export const FETCH_STOCK_ADJUSTMENT_FAIL = "FETCH_STOCK_ADJUSTMENT_FAIL";

export const ADD_STOCK_ADJUSTMENT_REQUEST = "ADD_STOCK_ADJUSTMENT_REQUEST";
export const ADD_STOCK_ADJUSTMENT_SUCCESS = "ADD_STOCK_ADJUSTMENT_SUCCESS";
export const ADD_STOCK_ADJUSTMENT_FAIL = "ADD_STOCK_ADJUSTMENT_FAIL";

